// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./decorators/toggleOpen/toggleOpen.sass
// module id = 563
// module chunks = 0